module.exports = __webpack_public_path__ + "static/media/wil_logo.b661622a.svg";